import qs from 'querystring'
 

import Api from '../lib/request'
import { itemList } from '../mock/item'
import cookie from '../lib/cookie'
import COOKIECONSTANT from '../constant/cookie'

const getQuestionDetail = (id) => {
  return new Promise((resolve, reject) => {
    Api.get(`${COOKIECONSTANT.REQUEST_HOST}?helpId=${id}`, {
        headers: {
          'X-Host': 'mall.cfg.help.info',
        }
      })
      .then((data) => {
        if(data.status != 0) {
          return reject(data.msg)
        }
        resolve(data.data)
      }, (e) => {
        reject(e)
      })
  })
}
const getQuestionList = ({ type, pageNum, pageSize }) => {
  return new Promise((resolve, reject) => {
    Api.get(`${COOKIECONSTANT.REQUEST_HOST}?type=${type}&pageNum=${pageNum}&pageSize=${pageSize}`, {
        headers: {
          'X-Host': 'mall.cfg.help.list',
        }
      })
      .then((data) => {
        if(data.status != 0) {
          return reject(data.msg)
        }
        resolve(data.data || [])
      }, (e) => {
        reject(e)
      })
  })
}
export default {
  getQuestionDetail,
  getQuestionList,
}
